import { render, staticRenderFns } from "./ListItemButtons.vue?vue&type=template&id=143b1c7d&"
import script from "./ListItemButtons.vue?vue&type=script&lang=js&"
export * from "./ListItemButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports